module.exports = __webpack_public_path__ + "media/images/icons/country_flags/fo-3165eadcb4c87a6d02ae982d07dbdd62.svg";